export const AUTH_CONFIG = {
  clientId: 'TlZd3M8F5BVzbQYfWy43mPqJikDnz34F',
  domain: 'dscarwash.auth0.com',
  callbackUrl: 'https://autowash.online/callback',
  // 'http://localhost:8080/callback',
  // 'https://fir-vue-de1f1.firebaseapp.com/callback'
  // 'https://autowash.online/callback'
  apiUrl: 'https://dscarwash.auth0.com/api/management'
};



// WEBPACK FOOTER //
// ./src/auth/auth0-variables.js